import { registerComponent } from '@gig/magic-common';
import RelevantInformation from './relevant-information.vue.js';

var RelevantInformationModal = registerComponent(RelevantInformation);

export { RelevantInformationModal };
